import React, { useEffect, useState, forwardRef } from 'react';
import ToolCard from './ToolCard';
import { Tool } from '../data/tools';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface ToolCategoryProps {
  title: string;
  description: string;
  tools: Tool[];
  isMobile?: boolean;
}
const ToolCategory = forwardRef<HTMLDivElement, ToolCategoryProps>(({
  title,
  description,
  tools,
  isMobile = false
}, ref) => {
  const [expanded, setExpanded] = useState(false);
  // Only use disclosure if there are at least 2 more items beyond the initial 5
  const shouldUseDisclosure = tools.length >= 7;
  const visibleTools = expanded || !shouldUseDisclosure ? tools : tools.slice(0, 5);
  // Create an ID from the title for scrolling, adding a suffix for mobile version
  // Special cases for specific categories
  const generateId = (title: string, isMobile: boolean) => {
    let baseId;
    if (title === 'Marketing & Design') {
      baseId = 'marketing-design';
    } else if (title === 'Coding & App Development') {
      baseId = 'coding-app-dev';
    } else {
      baseId = title.toLowerCase().replace(/\s+/g, '-');
    }
    return isMobile ? `${baseId}-mobile` : baseId;
  };
  const id = generateId(title, isMobile);
  useEffect(() => {
    console.log(`ToolCategory mounted with ID: ${id}`);
  }, [id]);
  return <div id={id} ref={ref} className="mb-8 bg-white dark:bg-dark-background rounded-lg border border-gray-200 dark:border-dark-border overflow-hidden" data-category-title={title} data-id="element-119">
        <div className="p-4 border-gray-200 dark:border-dark-border" data-id="element-120">
          <h2 className="text-xl font-medium text-text dark:text-dark-text mb-1" data-id="element-121">
            {title}
          </h2>
          <p className="text-text-meta dark:text-dark-text-meta mb-0" data-id="element-122">
            {description}
          </p>
        </div>
        <div data-id="element-123">
          {visibleTools.map((tool, index) => <ToolCard key={index} tool={tool} data-id="element-124" />)}
        </div>
        {shouldUseDisclosure && <button onClick={() => setExpanded(!expanded)} className="w-full p-3 hover:bg-[#F8F8F8] dark:hover:bg-dark-background-neutral-soft flex items-center justify-center border-t border-gray-200 dark:border-dark-border transition-colors" style={{
      color: '#0009'
    }} data-id="element-125">
            <span className="mr-1 dark:text-dark-text-meta" data-id="element-126">
              {expanded ? 'Show less' : 'Show all'}
            </span>
            {expanded ? <ChevronUpIcon className="w-4 h-4 dark:text-dark-text-meta" data-id="element-127" /> : <ChevronDownIcon className="w-4 h-4 dark:text-dark-text-meta" data-id="element-128" />}
          </button>}
      </div>;
});
export default ToolCategory;